import { useEffect, useState } from "react";
import { Download, Share } from "lucide-react";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { toast } from "sonner";

let deferredPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
});

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export const InstallAppItem = () => {
  const [canPrompt, setCanPrompt] = useState(!!deferredPrompt);

  useEffect(() => {
    const onPrompt = () => setCanPrompt(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (isStandalone()) return null;

  const install = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      deferredPrompt = null;
      setCanPrompt(false);
    } else if (isIOS()) {
      toast("Add to your home screen", { description: "Tap the Share button in Safari, then 'Add to Home Screen'.", duration: 8000 });
    } else {
      toast("Install the app", { description: "Open your browser menu and choose 'Install app' or 'Add to Home screen'.", duration: 8000 });
    }
  };

  return (
    <DropdownMenuItem onClick={install} data-testid="user-menu-install-app">
      {isIOS() && !canPrompt ? <Share size={15} className="mr-2" /> : <Download size={15} className="mr-2" />} Install app
    </DropdownMenuItem>
  );
};
